import { render, staticRenderFns } from "./BoardEmptyDefaultLayout.vue?vue&type=template&id=6e4cee84&scoped=true&"
import script from "./BoardEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BoardEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4cee84",
  null
  
)

export default component.exports